import { useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { IAvailableEntitlementsData } from "../types/misc.interface";
import { EEntitlementSource } from "../types/misc.enum";

export const useGetEntitlementsForAdminForm = (sourceId: string | null, source: EEntitlementSource) => {
    AuthHelper.presetPrivateRequest(api);

    const queryFn = async (): Promise<IAvailableEntitlementsData> => {
        const res = await api.get(`/entitlements/available/${source}/${sourceId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['entitlements-for-admin-form', source, sourceId],
        enabled: !!source && !!sourceId,
        queryFn,
    });
};